// extracted by mini-css-extract-plugin
module.exports = {"brazeContent":"brazeContent__3J3Of","captionedImage":"captionedImage__3B3xu","captionedContent":"captionedContent__2ftlO","banner":"banner__1do0i"};